import React, { useEffect, useCallback, useState } from "react";
import { connect } from "react-redux";

import { Skeleton, CollapseSection, UnderwritingForm } from "components";
import { isFeatureEnabled } from "helpers";

import JarisNotes from "./jarisNotes";
import { Merchant } from "./merchant";
import { Owners } from "./owners";

import styles from "./autoCheckList.module.scss";

const AutoCheckListContainer = ({
	loading,
	changeFormDisable,
	merchantInfoValues,
	isEditable,
	isHistorical,
	isEditableMerchantFieldOnHistorical,
	isDisabledOutcome,
	isEditExperianFields,
	isJarisApplication,
	underwritingFormName = "",
	isUnderwritingFormDisabled = false,
	loadingUnderwritingForm = false,
	decisionData = {},
}) => {
	const { applicationId, owner1, owner2, owner3, owner4, authorizedSigner } =
		merchantInfoValues || {};

	const [checkedMerchantValues, setCheckedMerchantValues] = useState({
		gVerifyMerchant: false,
		gOFACMerchant: false,
		matchMerchant: false,
		tinCheckMerchant: false,
	});
	const [checkedOwner1Values, setCheckedOwner1Values] = useState({
		gOFAC: false,
		gidentify: false,
		experian: false,
	});
	const [checkedOwner2Values, setCheckedOwner2Values] = useState({
		gOFAC: false,
		gidentify: false,
		experian: false,
	});
	const [checkedOwner3Values, setCheckedOwner3Values] = useState({
		gOFAC: false,
		gidentify: false,
		experian: false,
	});
	const [checkedOwner4Values, setCheckedOwner4Values] = useState({
		gOFAC: false,
		gidentify: false,
		experian: false,
	});
	const [checkedSignerValues, setCheckedSignerValues] = useState({
		gOFAC: false,
		gidentify: false,
		experian: false,
	});

	useEffect(() => {
		const applicableValues = [
			...Object.values(checkedMerchantValues),
			...(owner1 ? Object.values(checkedOwner1Values) : []),
			...(owner2 ? Object.values(checkedOwner2Values) : []),
			...(owner3 ? Object.values(checkedOwner3Values) : []),
			...(owner4 ? Object.values(checkedOwner4Values) : []),
			...(authorizedSigner ? Object.values(checkedSignerValues) : []),
		].filter(item => item != null);

		const isAllValuesPassed =
			applicableValues.length === 0 ||
			applicableValues.every(item => item === true);

		changeFormDisable?.(!isAllValuesPassed);
	}, [
		authorizedSigner,
		changeFormDisable,
		checkedMerchantValues,
		checkedOwner1Values,
		checkedOwner2Values,
		checkedOwner3Values,
		checkedOwner4Values,
		checkedSignerValues,
		owner1,
		owner2,
		owner3,
		owner4,
	]);

	const Loader = useCallback(
		({ skeleton, component }) => (loading ? skeleton : component),
		[loading],
	);

	return (
		<>
			{isJarisApplication && isFeatureEnabled("MMS-196-Jaris-POC") && (
				<CollapseSection
					header="Jaris UW Notes"
					className="mt-4"
					classNameHeaderContent={styles.collapseHeaderContent}
					arrowPosition="right"
				>
					<JarisNotes applicationId={applicationId} />
				</CollapseSection>
			)}
			<div className={styles.wrappAutoCheckListConstainer}>
				<div className={styles.checkListColumn}>
					<Loader
						skeleton={<Skeleton height="480px" />}
						component={
							<Merchant
								applicationId={applicationId}
								isEditable={isEditable}
								merchantInfoValues={merchantInfoValues}
								isEditableMerchantFieldOnHistorical={
									isEditableMerchantFieldOnHistorical
								}
								setCheckedValues={setCheckedMerchantValues}
								isDisabledOutcome={isDisabledOutcome}
								isJarisApplication={isJarisApplication}
							/>
						}
					/>
					{isEditable && !isHistorical && (
						<UnderwritingForm
							formName={underwritingFormName}
							loading={loadingUnderwritingForm}
							decisionData={decisionData}
							isFormDisabled={isUnderwritingFormDisabled}
							isFullWidth={true}
						/>
					)}
				</div>

				<div className={styles.checkListColumn}>
					<Loader
						skeleton={<Skeleton height="480px" />}
						component={
							<Owners
								loading={loading}
								merchantInfoValues={merchantInfoValues}
								setCheckedOwner1Values={setCheckedOwner1Values}
								setCheckedOwner2Values={setCheckedOwner2Values}
								setCheckedOwner3Values={setCheckedOwner3Values}
								setCheckedOwner4Values={setCheckedOwner4Values}
								setCheckedSignerValues={setCheckedSignerValues}
								isDisabledOutcome={isDisabledOutcome}
								isEditExperianFields={isEditExperianFields}
								isJarisApplication={isJarisApplication}
							/>
						}
					/>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = state => {
	return {
		loading: state.merchantInfo.loading,
		merchantInfoValues: state.merchantInfo.merchantInfo,
	};
};

export default connect(mapStateToProps)(AutoCheckListContainer);
